import { QueryHookOptions, useApolloClient, useQuery } from "@apollo/client";
import { User } from "@onmo/graphql/graphql";
import { getAAASubscriptionGQL } from "../graphql";
import { isActivatedSubscription } from "../models/user";

type SubscriptionData = { me: User };

export const useAAASubscription = (
  options?: QueryHookOptions<SubscriptionData>,
) => {
  const client = useApolloClient();

  const cached = client.readQuery<SubscriptionData>({
    query: getAAASubscriptionGQL,
  });

  const fetchPolicy =
    options?.fetchPolicy ??
    (isActivatedSubscription(cached?.me?.subscription)
      ? "cache-first"
      : options?.fetchPolicy ?? "cache-and-network");

  return useQuery<SubscriptionData>(getAAASubscriptionGQL, {
    ...options,
    fetchPolicy,
  });
};
